var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { IndesignRoute } from '../constants';
export var SDRoute;
(function (SDRoute) {
    SDRoute["start_session"] = "/api/v1/session/start/";
    SDRoute["create_instance"] = "/api/v1/entity/instances/";
    SDRoute["upload_content"] = "/api/fbd/v1/assetManager/upload/";
    SDRoute["update_content"] = "/api/fbd/v1/assetManager/update/";
    SDRoute["render_job"] = "/api/fbd/v1/jobs/";
    SDRoute["check_instance"] = "/api/v1/entity/instances/";
})(SDRoute || (SDRoute = {}));
/*
 * This is the killswitch for using SD.
 */
export var shouldSPRedirect = function () {
    return true;
};
/*
 * This determines which id_server routes are supported by SD.
 */
export var isRouteSupportedBySD = function (route) {
    switch (route) {
        case IndesignRoute.liner_ad_image:
            return true;
        case IndesignRoute.display_ad_image:
            return true;
        case IndesignRoute.display_ad_marginalia:
            return true;
        case IndesignRoute.paginate:
            return false;
        case IndesignRoute.paginate_rtf:
            return false;
        case IndesignRoute.health:
            return false;
        case IndesignRoute.template_specs:
            return false;
        default:
            return false;
    }
};
export var getSDTemplateID = function (noticeSnap) { return __awaiter(void 0, void 0, void 0, function () {
    var adTemplate;
    var _a, _b, _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0: return [4 /*yield*/, ((_b = (_a = noticeSnap.data()) === null || _a === void 0 ? void 0 : _a.adTemplate) === null || _b === void 0 ? void 0 : _b.get())];
            case 1:
                adTemplate = _d.sent();
                return [2 /*return*/, (_c = adTemplate === null || adTemplate === void 0 ? void 0 : adTemplate.data()) === null || _c === void 0 ? void 0 : _c.sdTemplateId];
        }
    });
}); };
export var getShouldUseSD = function (noticeSnap) { return __awaiter(void 0, void 0, void 0, function () {
    var sdTemplateId;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!shouldSPRedirect())
                    return [2 /*return*/, false];
                return [4 /*yield*/, getSDTemplateID(noticeSnap)];
            case 1:
                sdTemplateId = _a.sent();
                return [2 /*return*/, sdTemplateId];
        }
    });
}); };
